export const config = {
  rowSelection: false,
  fieldControl: false,
  columns: [
    {
      title: '来源',
      dataIndex: 'sourceTypeName',
      key: 'sourceTypeName',
      width: 120,
    },
    {
      title: '提交时间',
      dataIndex: 'createdTime',
      key: 'createdTime',
      width: 150,

      itemType:'dateTime'
    },
    {
      title: '数据量',
      dataIndex: 'totalSize',
      width: 120,
      key: 'totalSize',
    },
    {
      title: '状态',
      dataIndex: 'resultStatusName',
      key: 'resultStatusName',
      width: 150,
      render: 'statusRender' ,
    },
    {
      title: '成功条数',
      dataIndex: 'successSize',
      width: 120,
      key: 'successSize',
    },
    {
      title: '失败条数',
      dataIndex: 'failureSize',
      key: 'failureSize',
      width: 150,
      render:'failureSizeRender'
    },
    {
      title: '操作',
      dataIndex: 'handle',
      render: 'handleRender',
    }
  ],
  search: [],
  footer: [],
  batchActions: [],
}
